<template>
  <div
    class="fixed h-[40px] top-0 left-0 lg:left-[230px] w-full lg:w-[calc(100%-225px)] z-40 lg:z-20 drop-shadow-xl bg-white flex flex-row items-center justify-between"
  >
    <button @click="toggleSidebar()" class="mx-4 flex lg:hidden">
      <fas size="lg" :icon="['fas', 'align-justify']"></fas>
    </button>

    <div class="flex flex-row w-full lg:w-[250px] mx-2">
      <input
        class="w-full"
        placeholder="Buscar despacho por código"
        @keydown.enter="(event) => setSearch(event.target.value)"
      />
    </div>
    <div class="flex flex-row gap-4 items-center">
      <inline-svg src="../../assets/images/usuario.svg" title="My Image" />
      <router-link to="/account" class="">{{ user.name }}</router-link>
      <button
        class="btn-principal !h-[40px] w-[128px] text-lg font-semibold"
        href="#"
        @click.prevent="signOut"
      >
        Salir
      </button>
    </div>
  </div>
</template>

<script>
import Burger from "../../views/Menu/Burger.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { Burger },
  name: "Header",
  props: {
    signOut: Function,
    user: Object,
    pantalla: Boolean,
  },
  methods: {
    ...mapActions({
      cambiarFiltro: "filtros/cambiarFiltro",
      setDispatchSearch: "filtros/setDispatchSearch",
      cambiarFecha: "filtros/cambiarFecha",
    }),
    toggleSidebar() {
      const sidebar = document.getElementById("sidebar-wrapper");
      sidebar.classList.toggle("toggled");
    },
    async setSearch(searchQuery) {
      this.setDispatchSearch(searchQuery);

      if (searchQuery.trim() != "") {
        if (this.$route.name != "Despachos")
          this.$router.push({ name: "Despachos" });
      }
    },
  },
  mounted() {
    this.setDispatchSearch(null);
  },
};
</script>
